// 城市关键词库，用于城市热搜识别
// 按类别分组：直辖市、省会城市、地级市、县级市、港澳台、海外

export interface City {
  name: string;           // 城市名称
  aliases: string[];      // 别名/简称
  category: "直辖市" | "省会" | "地级市" | "县级市" | "港澳台" | "海外" | "其他";
  province: string;       // 所属省份
  tier: 1 | 2 | 3 | 4 | 5; // 城市等级：1一线, 2新一线, 3二线, 4三线, 5其他
}

// 直辖市
const municipalities: City[] = [
  { name: "北京", aliases: ["京城", "帝都", "北平"], category: "直辖市", province: "北京", tier: 1 },
  { name: "上海", aliases: ["魔都", "沪", "申城"], category: "直辖市", province: "上海", tier: 1 },
  { name: "天津", aliases: ["津", "津门"], category: "直辖市", province: "天津", tier: 2 },
  { name: "重庆", aliases: ["渝", "山城", "雾都"], category: "直辖市", province: "重庆", tier: 2 },
];

// 省会城市
const provincialCapitals: City[] = [
  { name: "广州", aliases: ["羊城", "花城", "穗"], category: "省会", province: "广东", tier: 1 },
  { name: "成都", aliases: ["蓉城", "锦官城", "天府之国"], category: "省会", province: "四川", tier: 2 },
  { name: "杭州", aliases: ["杭城", "临安", "钱塘"], category: "省会", province: "浙江", tier: 2 },
  { name: "武汉", aliases: ["江城", "汉口", "武昌"], category: "省会", province: "湖北", tier: 2 },
  { name: "西安", aliases: ["长安", "镐京", "古城"], category: "省会", province: "陕西", tier: 2 },
  { name: "南京", aliases: ["金陵", "建康", "石头城"], category: "省会", province: "江苏", tier: 2 },
  { name: "郑州", aliases: ["绿城", "商都"], category: "省会", province: "河南", tier: 2 },
  { name: "长沙", aliases: ["星城", "潭州"], category: "省会", province: "湖南", tier: 2 },
  { name: "沈阳", aliases: ["盛京", "奉天"], category: "省会", province: "辽宁", tier: 2 },
  { name: "青岛", aliases: ["岛城", "琴岛"], category: "省会", province: "山东", tier: 2 },
  { name: "宁波", aliases: ["甬城"], category: "省会", province: "浙江", tier: 2 },
  { name: "东莞", aliases: ["莞城"], category: "省会", province: "广东", tier: 2 },
  { name: "昆明", aliases: ["春城", "花都"], category: "省会", province: "云南", tier: 2 },
  { name: "合肥", aliases: ["庐州", "霸都"], category: "省会", province: "安徽", tier: 2 },
  { name: "佛山", aliases: ["禅城"], category: "省会", province: "广东", tier: 2 },
  { name: "石家庄", aliases: ["石门"], category: "省会", province: "河北", tier: 3 },
  { name: "太原", aliases: ["龙城", "并州"], category: "省会", province: "山西", tier: 3 },
  { name: "济南", aliases: ["泉城"], category: "省会", province: "山东", tier: 2 },
  { name: "长春", aliases: ["北国春城"], category: "省会", province: "吉林", tier: 3 },
  { name: "哈尔滨", aliases: ["冰城", "东方莫斯科"], category: "省会", province: "黑龙江", tier: 2 },
  { name: "福州", aliases: ["榕城"], category: "省会", province: "福建", tier: 2 },
  { name: "南昌", aliases: ["洪城", "英雄城"], category: "省会", province: "江西", tier: 3 },
  { name: "贵阳", aliases: ["筑城", "林城"], category: "省会", province: "贵州", tier: 3 },
  { name: "海口", aliases: ["椰城"], category: "省会", province: "海南", tier: 3 },
  { name: "兰州", aliases: ["金城"], category: "省会", province: "甘肃", tier: 3 },
  { name: "西宁", aliases: ["夏都"], category: "省会", province: "青海", tier: 4 },
  { name: "拉萨", aliases: ["日光城"], category: "省会", province: "西藏", tier: 4 },
  { name: "银川", aliases: ["凤凰城"], category: "省会", province: "宁夏", tier: 4 },
  { name: "乌鲁木齐", aliases: ["乌市", "迪化"], category: "省会", province: "新疆", tier: 3 },
  { name: "南宁", aliases: ["绿城", "邕城"], category: "省会", province: "广西", tier: 3 },
  { name: "呼和浩特", aliases: ["青城", "呼市"], category: "省会", province: "内蒙古", tier: 3 },
];

// 地级市（热门城市）
const prefectureCities: City[] = [
  { name: "深圳", aliases: ["鹏城", "特区"], category: "地级市", province: "广东", tier: 1 },
  { name: "苏州", aliases: ["姑苏", "东方威尼斯"], category: "地级市", province: "江苏", tier: 2 },
  { name: "无锡", aliases: ["锡城"], category: "地级市", province: "江苏", tier: 2 },
  { name: "厦门", aliases: ["鹭岛", "厦"], category: "地级市", province: "福建", tier: 2 },
  { name: "大连", aliases: ["滨城", "北方明珠"], category: "地级市", province: "辽宁", tier: 2 },
  { name: "温州", aliases: ["鹿城"], category: "地级市", province: "浙江", tier: 2 },
  { name: "常州", aliases: ["龙城"], category: "地级市", province: "江苏", tier: 2 },
  { name: "南通", aliases: ["静海", "崇川"], category: "地级市", province: "江苏", tier: 2 },
  { name: "嘉兴", aliases: ["禾城"], category: "地级市", province: "浙江", tier: 2 },
  { name: "绍兴", aliases: ["越城"], category: "地级市", province: "浙江", tier: 2 },
  { name: "珠海", aliases: ["百岛之市"], category: "地级市", province: "广东", tier: 2 },
  { name: "惠州", aliases: ["鹅城"], category: "地级市", province: "广东", tier: 2 },
  { name: "中山", aliases: ["香山"], category: "地级市", province: "广东", tier: 2 },
  { name: "泉州", aliases: ["鲤城"], category: "地级市", province: "福建", tier: 2 },
  { name: "烟台", aliases: ["港城"], category: "地级市", province: "山东", tier: 2 },
  { name: "唐山", aliases: ["凤凰城", "北方瓷都"], category: "地级市", province: "河北", tier: 3 },
  { name: "徐州", aliases: ["彭城"], category: "地级市", province: "江苏", tier: 3 },
  { name: "扬州", aliases: ["广陵", "淮左名都"], category: "地级市", province: "江苏", tier: 3 },
  { name: "镇江", aliases: ["京口"], category: "地级市", province: "江苏", tier: 3 },
  { name: "泰州", aliases: ["凤城"], category: "地级市", province: "江苏", tier: 3 },
  { name: "台州", aliases: ["海州"], category: "地级市", province: "浙江", tier: 3 },
  { name: "金华", aliases: ["婺州"], category: "地级市", province: "浙江", tier: 3 },
  { name: "临沂", aliases: ["琅琊"], category: "地级市", province: "山东", tier: 3 },
  { name: "潍坊", aliases: ["鸢都"], category: "地级市", province: "山东", tier: 3 },
  { name: "淄博", aliases: ["淄州"], category: "地级市", province: "山东", tier: 3 },
  { name: "威海", aliases: ["威海卫"], category: "地级市", province: "山东", tier: 3 },
  { name: "洛阳", aliases: ["洛邑", "神都", "九朝古都"], category: "地级市", province: "河南", tier: 3 },
  { name: "南阳", aliases: ["宛城"], category: "地级市", province: "河南", tier: 3 },
  { name: "新乡", aliases: ["牧野"], category: "地级市", province: "河南", tier: 3 },
  { name: "邯郸", aliases: ["赵都"], category: "地级市", province: "河北", tier: 3 },
  { name: "保定", aliases: ["靴城"], category: "地级市", province: "河北", tier: 3 },
  { name: "襄阳", aliases: ["襄樊"], category: "地级市", province: "湖北", tier: 3 },
  { name: "宜昌", aliases: ["夷陵"], category: "地级市", province: "湖北", tier: 3 },
  { name: "岳阳", aliases: ["巴陵"], category: "地级市", province: "湖南", tier: 3 },
  { name: "常德", aliases: ["武陵"], category: "地级市", province: "湖南", tier: 3 },
  { name: "株洲", aliases: ["建宁"], category: "地级市", province: "湖南", tier: 3 },
  { name: "湘潭", aliases: ["潭城"], category: "地级市", province: "湖南", tier: 3 },
  { name: "芜湖", aliases: ["鸠兹"], category: "地级市", province: "安徽", tier: 3 },
  { name: "蚌埠", aliases: ["珠城"], category: "地级市", province: "安徽", tier: 3 },
  { name: "阜阳", aliases: ["颍州"], category: "地级市", province: "安徽", tier: 3 },
  { name: "九江", aliases: ["浔阳"], category: "地级市", province: "江西", tier: 3 },
  { name: "赣州", aliases: ["虔城"], category: "地级市", province: "江西", tier: 3 },
  { name: "桂林", aliases: ["桂州"], category: "地级市", province: "广西", tier: 3 },
  { name: "柳州", aliases: ["龙城"], category: "地级市", province: "广西", tier: 3 },
  { name: "三亚", aliases: ["崖州"], category: "地级市", province: "海南", tier: 3 },
  { name: "绵阳", aliases: ["绵州"], category: "地级市", province: "四川", tier: 3 },
  { name: "德阳", aliases: ["旌城"], category: "地级市", province: "四川", tier: 3 },
  { name: "南充", aliases: ["果城"], category: "地级市", province: "四川", tier: 3 },
  { name: "遵义", aliases: ["红城"], category: "地级市", province: "贵州", tier: 3 },
  { name: "大理", aliases: ["叶榆"], category: "地级市", province: "云南", tier: 3 },
  { name: "丽江", aliases: ["大研"], category: "地级市", province: "云南", tier: 3 },
  { name: "桂林", aliases: [], category: "地级市", province: "广西", tier: 3 },
  { name: "包头", aliases: ["鹿城"], category: "地级市", province: "内蒙古", tier: 3 },
  { name: "鄂尔多斯", aliases: ["伊盟"], category: "地级市", province: "内蒙古", tier: 3 },
  { name: "榆林", aliases: ["驼城"], category: "地级市", province: "陕西", tier: 3 },
  { name: "咸阳", aliases: ["渭城"], category: "地级市", province: "陕西", tier: 3 },
  { name: "宝鸡", aliases: ["陈仓", "雍城"], category: "地级市", province: "陕西", tier: 3 },
  { name: "三亚", aliases: [], category: "地级市", province: "海南", tier: 3 },
  { name: "珠海", aliases: [], category: "地级市", province: "广东", tier: 2 },
  { name: "汕头", aliases: ["鮀城"], category: "地级市", province: "广东", tier: 3 },
  { name: "湛江", aliases: ["港城"], category: "地级市", province: "广东", tier: 3 },
  { name: "江门", aliases: ["五邑"], category: "地级市", province: "广东", tier: 3 },
  { name: "肇庆", aliases: ["端州"], category: "地级市", province: "广东", tier: 3 },
  { name: "梅州", aliases: ["嘉应"], category: "地级市", province: "广东", tier: 4 },
  { name: "清远", aliases: ["凤城"], category: "地级市", province: "广东", tier: 4 },
  { name: "茂名", aliases: ["油城"], category: "地级市", province: "广东", tier: 4 },
  { name: "韶关", aliases: ["韶州"], category: "地级市", province: "广东", tier: 4 },
  { name: "阳江", aliases: ["鼍城"], category: "地级市", province: "广东", tier: 4 },
  { name: "河源", aliases: ["槎城"], category: "地级市", province: "广东", tier: 4 },
  { name: "汕尾", aliases: ["海陆丰"], category: "地级市", province: "广东", tier: 4 },
  { name: "揭阳", aliases: ["榕城"], category: "地级市", province: "广东", tier: 4 },
  { name: "云浮", aliases: ["石都"], category: "地级市", province: "广东", tier: 5 },
  { name: "潮州", aliases: ["凤城"], category: "地级市", province: "广东", tier: 4 },
];

// 港澳台
const specialRegions: City[] = [
  { name: "香港", aliases: ["港", "HK", "Hong Kong"], category: "港澳台", province: "香港", tier: 2 },
  { name: "澳门", aliases: ["澳", "Macau", "Macao"], category: "港澳台", province: "澳门", tier: 3 },
  { name: "台北", aliases: ["北市", "Taipei"], category: "港澳台", province: "台湾", tier: 2 },
  { name: "高雄", aliases: ["港都", "Kaohsiung"], category: "港澳台", province: "台湾", tier: 3 },
  { name: "台中", aliases: ["中市", "Taichung"], category: "港澳台", province: "台湾", tier: 3 },
  { name: "台南", aliases: ["南市", "Tainan"], category: "港澳台", province: "台湾", tier: 3 },
  { name: "桃园", aliases: ["Taoyuan"], category: "港澳台", province: "台湾", tier: 3 },
  { name: "新竹", aliases: ["Hsinchu"], category: "港澳台", province: "台湾", tier: 3 },
  { name: "基隆", aliases: ["Keelung"], category: "港澳台", province: "台湾", tier: 4 },
];

// 海外热门城市
const overseas: City[] = [
  { name: "纽约", aliases: ["New York", "NYC", "大苹果"], category: "海外", province: "美国", tier: 1 },
  { name: "洛杉矶", aliases: ["Los Angeles", "LA", "天使之城"], category: "海外", province: "美国", tier: 1 },
  { name: "旧金山", aliases: ["San Francisco", "三藩市", "金门城"], category: "海外", province: "美国", tier: 1 },
  { name: "芝加哥", aliases: ["Chicago", "风城"], category: "海外", province: "美国", tier: 2 },
  { name: "西雅图", aliases: ["Seattle", "翡翠之城"], category: "海外", province: "美国", tier: 2 },
  { name: "波士顿", aliases: ["Boston", "豆城"], category: "海外", province: "美国", tier: 2 },
  { name: "华盛顿", aliases: ["Washington DC", "华府"], category: "海外", province: "美国", tier: 2 },
  { name: "迈阿密", aliases: ["Miami", "魔术城"], category: "海外", province: "美国", tier: 2 },
  { name: "拉斯维加斯", aliases: ["Las Vegas", "赌城"], category: "海外", province: "美国", tier: 2 },
  { name: "东京", aliases: ["Tokyo", "江户"], category: "海外", province: "日本", tier: 1 },
  { name: "大阪", aliases: ["Osaka", "浪速"], category: "海外", province: "日本", tier: 2 },
  { name: "京都", aliases: ["Kyoto"], category: "海外", province: "日本", tier: 2 },
  { name: "名古屋", aliases: ["Nagoya"], category: "海外", province: "日本", tier: 2 },
  { name: "札幌", aliases: ["Sapporo"], category: "海外", province: "日本", tier: 3 },
  { name: "福冈", aliases: ["Fukuoka"], category: "海外", province: "日本", tier: 3 },
  { name: "首尔", aliases: ["Seoul", "汉城"], category: "海外", province: "韩国", tier: 1 },
  { name: "釜山", aliases: ["Busan", "Pusan"], category: "海外", province: "韩国", tier: 2 },
  { name: "仁川", aliases: ["Incheon"], category: "海外", province: "韩国", tier: 3 },
  { name: "伦敦", aliases: ["London", "雾都"], category: "海外", province: "英国", tier: 1 },
  { name: "曼彻斯特", aliases: ["Manchester"], category: "海外", province: "英国", tier: 2 },
  { name: "爱丁堡", aliases: ["Edinburgh"], category: "海外", province: "英国", tier: 2 },
  { name: "巴黎", aliases: ["Paris", "光之城"], category: "海外", province: "法国", tier: 1 },
  { name: "马赛", aliases: ["Marseille"], category: "海外", province: "法国", tier: 2 },
  { name: "里昂", aliases: ["Lyon"], category: "海外", province: "法国", tier: 2 },
  { name: "柏林", aliases: ["Berlin"], category: "海外", province: "德国", tier: 1 },
  { name: "慕尼黑", aliases: ["Munich", "München"], category: "海外", province: "德国", tier: 2 },
  { name: "法兰克福", aliases: ["Frankfurt"], category: "海外", province: "德国", tier: 2 },
  { name: "汉堡", aliases: ["Hamburg"], category: "海外", province: "德国", tier: 2 },
  { name: "罗马", aliases: ["Rome", "Roma", "永恒之城"], category: "海外", province: "意大利", tier: 1 },
  { name: "米兰", aliases: ["Milan", "Milano", "时尚之都"], category: "海外", province: "意大利", tier: 2 },
  { name: "威尼斯", aliases: ["Venice", "Venezia", "水城"], category: "海外", province: "意大利", tier: 2 },
  { name: "马德里", aliases: ["Madrid"], category: "海外", province: "西班牙", tier: 1 },
  { name: "巴塞罗那", aliases: ["Barcelona"], category: "海外", province: "西班牙", tier: 1 },
  { name: "莫斯科", aliases: ["Moscow", "Москва"], category: "海外", province: "俄罗斯", tier: 1 },
  { name: "圣彼得堡", aliases: ["Saint Petersburg", "列宁格勒"], category: "海外", province: "俄罗斯", tier: 2 },
  { name: "悉尼", aliases: ["Sydney"], category: "海外", province: "澳大利亚", tier: 1 },
  { name: "墨尔本", aliases: ["Melbourne"], category: "海外", province: "澳大利亚", tier: 1 },
  { name: "多伦多", aliases: ["Toronto"], category: "海外", province: "加拿大", tier: 1 },
  { name: "温哥华", aliases: ["Vancouver"], category: "海外", province: "加拿大", tier: 1 },
  { name: "蒙特利尔", aliases: ["Montreal"], category: "海外", province: "加拿大", tier: 2 },
  { name: "新加坡", aliases: ["Singapore", "狮城", "星洲"], category: "海外", province: "新加坡", tier: 1 },
  { name: "曼谷", aliases: ["Bangkok"], category: "海外", province: "泰国", tier: 2 },
  { name: "吉隆坡", aliases: ["Kuala Lumpur", "KL"], category: "海外", province: "马来西亚", tier: 2 },
  { name: "迪拜", aliases: ["Dubai"], category: "海外", province: "阿联酋", tier: 1 },
  { name: "孟买", aliases: ["Mumbai", "Bombay"], category: "海外", province: "印度", tier: 2 },
  { name: "新德里", aliases: ["New Delhi"], category: "海外", province: "印度", tier: 2 },
  { name: "伊斯坦布尔", aliases: ["Istanbul"], category: "海外", province: "土耳其", tier: 2 },
  { name: "开罗", aliases: ["Cairo"], category: "海外", province: "埃及", tier: 2 },
  { name: "约翰内斯堡", aliases: ["Johannesburg"], category: "海外", province: "南非", tier: 2 },
  { name: "开普敦", aliases: ["Cape Town"], category: "海外", province: "南非", tier: 2 },
  { name: "里约热内卢", aliases: ["Rio de Janeiro"], category: "海外", province: "巴西", tier: 2 },
  { name: "圣保罗", aliases: ["São Paulo"], category: "海外", province: "巴西", tier: 2 },
  { name: "墨西哥城", aliases: ["Mexico City"], category: "海外", province: "墨西哥", tier: 2 },
  { name: "奥克兰", aliases: ["Auckland"], category: "海外", province: "新西兰", tier: 2 },
  { name: "阿姆斯特丹", aliases: ["Amsterdam"], category: "海外", province: "荷兰", tier: 2 },
  { name: "布鲁塞尔", aliases: ["Brussels"], category: "海外", province: "比利时", tier: 2 },
  { name: "苏黎世", aliases: ["Zurich"], category: "海外", province: "瑞士", tier: 2 },
  { name: "日内瓦", aliases: ["Geneva"], category: "海外", province: "瑞士", tier: 2 },
  { name: "维也纳", aliases: ["Vienna", "音乐之都"], category: "海外", province: "奥地利", tier: 2 },
  { name: "布拉格", aliases: ["Prague"], category: "海外", province: "捷克", tier: 2 },
  { name: "华沙", aliases: ["Warsaw"], category: "海外", province: "波兰", tier: 2 },
  { name: "雅典", aliases: ["Athens"], category: "海外", province: "希腊", tier: 2 },
  { name: "斯德哥尔摩", aliases: ["Stockholm"], category: "海外", province: "瑞典", tier: 2 },
  { name: "奥斯陆", aliases: ["Oslo"], category: "海外", province: "挪威", tier: 2 },
  { name: "哥本哈根", aliases: ["Copenhagen"], category: "海外", province: "丹麦", tier: 2 },
  { name: "赫尔辛基", aliases: ["Helsinki"], category: "海外", province: "芬兰", tier: 2 },
];

// 合并所有城市
export const CITIES: City[] = [
  ...municipalities,
  ...provincialCapitals,
  ...prefectureCities,
  ...specialRegions,
  ...overseas,
];

// 构建城市名称到城市对象的映射
export const CITY_MAP: Map<string, City> = new Map();

CITIES.forEach((city) => {
  // 添加主名称
  CITY_MAP.set(city.name, city);
  // 添加别名
  city.aliases.forEach((alias) => {
    CITY_MAP.set(alias, city);
  });
});

// 获取所有城市名称（用于匹配）
export function getAllCityNames(): string[] {
  const names: string[] = [];
  CITIES.forEach((city) => {
    names.push(city.name);
    names.push(...city.aliases);
  });
  return names;
}

// 从文本中识别城市
export function extractCitiesFromText(text: string): City[] {
  const foundCities = new Set<City>();
  const cityNames = getAllCityNames();

  // 按名称长度降序排序，优先匹配长名称
  const sortedNames = cityNames.sort((a, b) => b.length - a.length);

  for (const name of sortedNames) {
    if (text.includes(name)) {
      const city = CITY_MAP.get(name);
      if (city) {
        foundCities.add(city);
      }
    }
  }

  return Array.from(foundCities);
}

// 根据城市名称获取城市信息
export function getCityByName(name: string): City | undefined {
  return CITY_MAP.get(name);
}

// 按类别分组的城市
export function getCitiesByCategory(): Map<string, City[]> {
  const map = new Map<string, City[]>();
  CITIES.forEach((city) => {
    const list = map.get(city.category) || [];
    list.push(city);
    map.set(city.category, list);
  });
  return map;
}

// 按省份分组的城市
export function getCitiesByProvince(): Map<string, City[]> {
  const map = new Map<string, City[]>();
  CITIES.forEach((city) => {
    const list = map.get(city.province) || [];
    list.push(city);
    map.set(city.province, list);
  });
  return map;
}

// 按等级分组的城市
export function getCitiesByTier(): Map<number, City[]> {
  const map = new Map<number, City[]>();
  CITIES.forEach((city) => {
    const list = map.get(city.tier) || [];
    list.push(city);
    map.set(city.tier, list);
  });
  return map;
}

// 获取热门城市（一线和新一线）
export function getHotCities(): City[] {
  return CITIES.filter((city) => city.tier <= 2);
}

// 判断文本是否包含城市名
export function containsCityName(text: string): boolean {
  return extractCitiesFromText(text).length > 0;
}
